import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import {
    doWebsocketReconnect,
    selectFailedServices,
    selectIsAllServicesFailed,
    selectWebsocketStatus
} from 'app/store/websocketStatus';
import { ConnectionLostOverlay } from './ConnectionLostOverlay.jsx';

const mapStateToProps = createStructuredSelector({
    status: selectWebsocketStatus,
    failedServices: selectFailedServices,
    isAllFailed: selectIsAllServicesFailed
});

const mapDispatchToProps = {
    onReconnect: doWebsocketReconnect
};

export const ConnectionLostOverlayContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(ConnectionLostOverlay);
